
import MonitorMobile from "../../../assets/filled/MonitorMobile.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MonitorMobileIcon({ className, dataTestid = "MonitorMobileIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MonitorMobile data-testid={dataTestid} className={classes} {...rest} />
  );
}
